/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `VisibilityIconProps` interface defines the properties for the VisibilityIcon component.
 */
interface VisibilityIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "visibility" — outlined, weight 300.
 * Eye icon for showing password fields.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const VisibilityIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'VisibilityIcon',
    width
}: VisibilityIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 240q113 0 207.5-59.5T832-500q-50-121-144.5-180.5T480-740q-113 0-207.5 59.5T128-500q50 121 144.5 180.5T480-260Z" />
    </svg>
);

VisibilityIcon.displayName = 'VisibilityIcon';